export default __webpack_public_path__ + "static/media/aboutill.dbfdb689.svg";